class VideoBlock {
  #media;
  #playBtn;
  #video = null;
  #iframe = null;
  #overlay = null;
  #isPaused = false;

  constructor(section) {
    this.#media   = section.querySelector('.humble-video-block__media');
    this.#playBtn = section.querySelector('.humble-video-block__play');
    if (!this.#media || !this.#playBtn) return;

    this.#playBtn.addEventListener('click', () => this.#onPlayClick());
  }

  #onPlayClick() {
    if (!this.#media.classList.contains('is-playing')) {
      this.#startPlayback();
      return;
    }
    // Already playing (paused state) → resume
    this.#resume();
  }

  #startPlayback() {
    const embedSrc = this.#media.dataset.embedSrc;

    if (embedSrc) {
      // External video (YouTube / Vimeo)
      this.#iframe = document.createElement('iframe');
      this.#iframe.src = embedSrc;
      this.#iframe.className = 'humble-video-block__embed';
      this.#iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      this.#iframe.setAttribute('allowfullscreen', '');
      this.#media.appendChild(this.#iframe);

      // Transparent overlay so clicks on the video reach us (not the iframe)
      this.#overlay = document.createElement('div');
      this.#overlay.className = 'humble-video-block__click-overlay';
      this.#overlay.addEventListener('click', () => this.#pause());
      this.#media.appendChild(this.#overlay);
    } else {
      // Shopify native video
      this.#video = this.#media.querySelector('.humble-video-block__video');
      if (this.#video) {
        this.#video.addEventListener('pause', () => this.#onNativePause());
        this.#video.addEventListener('play',  () => this.#onNativePlay());
        this.#video.play();
      }
    }

    this.#media.classList.add('is-playing');
    this.#media.classList.remove('is-paused');
  }

  #pause() {
    this.#media.classList.add('is-paused');
    if (this.#video) {
      this.#video.pause();
    } else if (this.#iframe) {
      this.#postMessage('pause');
      // Hide the click overlay while the play button is shown
      if (this.#overlay) this.#overlay.style.display = 'none';
    }
  }

  #resume() {
    this.#media.classList.remove('is-paused');
    if (this.#video) {
      this.#video.play();
    } else if (this.#iframe) {
      this.#postMessage('play');
      // Restore the click overlay
      if (this.#overlay) this.#overlay.style.display = '';
    }
  }

  // Sync UI with native video element events (e.g. user uses native controls bar)
  #onNativePause() {
    this.#media.classList.add('is-paused');
  }

  #onNativePlay() {
    this.#media.classList.remove('is-paused');
  }

  #postMessage(action) {
    if (!this.#iframe) return;
    const src = this.#iframe.src;
    if (src.includes('youtube.com')) {
      this.#iframe.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: action === 'pause' ? 'pauseVideo' : 'playVideo', args: '' }),
        '*'
      );
    } else if (src.includes('vimeo.com')) {
      this.#iframe.contentWindow.postMessage(
        JSON.stringify({ method: action }),
        'https://player.vimeo.com'
      );
    }
  }
}

const init = () => {
  document.querySelectorAll('.humble-video-block').forEach((section) => new VideoBlock(section));
};

if (['interactive', 'complete'].includes(document.readyState)) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
